import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from 'react-router-dom'
import { ChakraProvider } from '@chakra-ui/react'
import Inputcontextprovider from "./Contexts/Inputcontext.jsx"
import Cartcontextprovider from "./Contexts/Cartcontext.jsx"
import AuthContextProvider from './Contexts/Authcontext';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthContextProvider> 
  <Cartcontextprovider>
  <Inputcontextprovider>
  <BrowserRouter>
   <ChakraProvider>
    <App />
   </ChakraProvider>
  </BrowserRouter>
  </Inputcontextprovider>
  </Cartcontextprovider>
  </AuthContextProvider>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
